import {
  IonAvatar,
  IonButton,
  IonCard,
  IonCardContent,
  IonChip,
  IonIcon,
  IonLabel,
  IonRippleEffect
} from "@ionic/react";
import { Rating } from "@mui/material";
import { shareOutline } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { hapticPatterns } from "../../utils/haptics";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import { shareChef } from "../../utils/sharing";
import { Aa } from "../functions/Aa";
import "../styles/discover-our-chef.css";
import "./chef-card-ionic.css";

const ChefCard = ({ chef, selectedWhen, setChef }) => {
  const history = useHistory();
  const useMobileUI = shouldUseIonicComponents();

  const handleCardClick = async () => {
    await hapticPatterns.buttonClick();
    setChef(chef);
    history.push(`/order/chef/menu?chef=${chef?._id}&date=${selectedWhen}`);
  };

  const handleShare = async (e) => {
    e.stopPropagation(); // Prevent card click
    await hapticPatterns.buttonClick();
    const shared = await shareChef(chef);
    if (!shared) {
      // If native share failed, show toast that link was copied
      // This will be handled by the sharing utility
    }
  };

  // Calculate rating
  const rating =
    chef?.review_count === 0 ? 0 : chef?.stars_count / chef?.review_count;

  // Render Ionic version for mobile
  if (useMobileUI) {
    return (
      <IonCard
        className="ionic-chef-card"
        onClick={handleCardClick}
        button={true}
      >
        <IonRippleEffect />

        <div className="ionic-chef-card-image-container">
          <img
            src={chef?.preview}
            alt={`${chef?.firstname} ${chef?.lastname}`}
            className="ionic-chef-card-preview"
          />

          {chef?.geographical_tag && (
            <IonChip className="ionic-chef-card-country-chip" color="warning">
              <IonLabel>{Aa(chef?.geographical_tag?.toLowerCase())}</IonLabel>
            </IonChip>
          )}

          <IonButton
            fill="clear"
            size="small"
            onClick={handleShare}
            className="ionic-chef-share-btn"
          >
            <IonIcon icon={shareOutline} />
          </IonButton>
        </div>

        <IonCardContent className="ionic-chef-card-content">
          <div className="ionic-chef-info">
            <IonAvatar className="ionic-chef-avatar">
              <img src={chef?.pic1} alt={chef?.firstname} />
            </IonAvatar>

            <div className="ionic-chef-details">
              <h3 className="ionic-chef-name">
                {chef?.chef ? "Chef" : "Restaurant"} {Aa(chef?.firstname)}{" "}
                {Aa(chef?.lastname)}
              </h3>

              <div className="ionic-chef-rating">
                {[...Array(5)].map((_, index) => (
                  <span
                    key={index}
                    className={
                      index < Math.floor(rating) ? "star filled" : "star"
                    }
                  >
                    ★
                  </span>
                ))}
                <span className="rating-count">
                  ({chef?.review_count || 0})
                </span>
              </div>
            </div>
          </div>
        </IonCardContent>
      </IonCard>
    );
  }

  // Render web version (existing design)
  return (
    <div onClick={handleCardClick}>
      <div className="section-chef-card">
        <div className="chef-card">
          <div className="chef-item">
            <span className="chef-card-country">
              {Aa(chef?.geographical_tag?.toLowerCase())}
            </span>
            <img
              src={chef?.preview}
              alt=""
              style={{
                objectFit: "cover"
              }}
            />
            <div className="chef">
              <img
                src={chef?.pic1}
                alt=""
                style={{
                  objectFit: "cover",
                  borderRadius: 20
                }}
              />
              <div>
                <p
                  style={{
                    textAlign: "left"
                  }}
                >
                  {chef?.chef ? "Chef" : "Restaurant"}{" "}
                  {Aa(chef?.firstname) + " " + Aa(chef?.lastname)}
                </p>
                <Rating
                  value={rating}
                  readOnly
                  precision={0.5}
                  style={{
                    marginTop: -10
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChefCard;
